import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import DealerRevenueHeatmap from './DealerRevenueHeatmap';
import DealerFunnelChart from './DealerFunnelChart';
import DealerWalletShareMatrix from './DealerWalletShareMatrix';
import DealerPerformanceTable from './DealerPerformanceTable';
const DealerPerformanceDashboard: React.FC = () => {
  const kpis = [{
    title: 'Active Dealers',
    value: '534',
    change: '+28',
    isPositive: true,
    subtitle: 'Network size'
  }, {
    title: 'Average Dealer Revenue',
    value: '₹5.54 Cr',
    change: '+8.2%',
    isPositive: true,
    subtitle: 'Per dealer annually'
  }, {
    title: 'Return Rate %',
    value: '2.8%',
    change: '-0.4%',
    isPositive: true,
    subtitle: 'Product returns'
  }, {
    title: 'Dealer Satisfaction Score',
    value: '8.2/10',
    change: '+0.3',
    isPositive: true,
    subtitle: 'Quarterly survey'
  }];
  return <div data-id="element-7136">
      <DescriptionPanel title="Dealer/Distributor Performance" description="Comprehensive analysis of dealer network health, revenue distribution, and performance metrics. Monitor dealer productivity, satisfaction levels, and wallet share opportunities to strengthen distribution channels and drive aftermarket growth." insights={['Active dealer network expanded to 534 dealers - 28 new additions', 'Average dealer revenue at ₹5.54 Cr with 8.2% YoY growth', 'Maharashtra leading with ₹485 Cr dealer revenue across 78 dealers', 'Top 20% dealers contributing 58% of total dealer revenue']} data-id="element-7137" />
      {/* KPI Tiles */}
      <div className="mb-8" data-id="element-7138">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-7139">
          Dealer Network Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-7140">
          {kpis.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50" data-id="element-7141">
              <div className="flex flex-col h-full" data-id="element-7142">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1" data-id="element-7143">
                  {kpi.title}
                </div>
                <div className="text-xs text-gray-400 mb-3" data-id="element-7144">{kpi.subtitle}</div>
                <div className="text-4xl font-bold text-gray-900 mb-3" data-id="element-7145">
                  {kpi.value}
                </div>
                <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-7146">
                  {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-7147" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-7148" />}
                  {kpi.change} vs last quarter
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Dealer Revenue Heatmap - Full Width */}
      <DealerRevenueHeatmap data-id="element-7149" />
      {/* Main Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-7150">
        <DealerFunnelChart data-id="element-7151" />
        <DealerWalletShareMatrix data-id="element-7152" />
      </div>
      {/* Dealer Performance Table */}
      <DealerPerformanceTable data-id="element-7153" />
    </div>;
};
export default DealerPerformanceDashboard;